import http from './http';
import request from './request';

export { default as FetchData } from '../components/FetchData';

export default { request, http };
